import * as React from 'react';
import { Header3, InlineText2, Walk16, Car16 } from '@cian/ui-kit';

import { IPlaceNearby } from '../../../../types/newbuilding/placesNearby';
import { ETransportType } from '../../../../types/transportType';

import * as styles from './styles.css';

export function PlacesNearbyItem({ image, title, distance, transportType }: IPlaceNearby) {
  return (
    <div>
      <div className={styles['img']} style={{ backgroundImage: `url(${image.url})` }} />
      <div className={styles['title']}>
        <Header3 as="h3">{title}</Header3>
      </div>
      {distance && transportType && (
        <div className={styles['distance']}>
          {transportType === ETransportType.Walk ? <Walk16 color="gray60_100" /> : <Car16 color="gray60_100" />}
          <InlineText2 color="gray60_100">{distance}</InlineText2>
        </div>
      )}
    </div>
  );
}
